import { isBrowser } from '../utils/environment'

export const LOG_TYPES = {
  DEFAULT: 'Log',
  ERROR: 'Error',
  EVENT: 'Event',
  SETI: 'Seti',
  WARNING: 'Warning',
}
const MAX_LOG_KEYS = 50
const MAX_LOG_STRING_LENGTH = 1000

export class Log {
  constructor(data, provider) {
    this.type = LOG_TYPES.DEFAULT
    this.data = data
    this.timestamp = new Date()
    this.provider = provider

    if (isBrowser()) this.url = window.location.href
  }

  serialize() {
    const data = {}
    let keySize = 0

    for (const prop in this.data) {
      if (keySize > MAX_LOG_KEYS) break

      let value = this.data[prop]

      // Ignore null/undefined values
      if (!value) continue
      // Ignore Objects && Arrays
      if (typeof value === 'object' && value instanceof Date === false) continue
      // Trim strings if necessary
      if (typeof value === 'string' && value.length > MAX_LOG_STRING_LENGTH) {
        value = `[TRUNC] ${value.substring(0, MAX_LOG_STRING_LENGTH)}`
      }

      data[prop] = value
      keySize++
    }

    // Gonzo 7/24/2017 - The line below breaks GA by overwriting the "action" property.
    //   However, it looks like other logging, such as Elasticsearch, depends on that "action" value being present.
    //   So for now we only override it when there is no action already present.
    if (data.action === null || data.action === undefined) {
      data.action = this.type
    }

    data.timestamp = this.timestamp

    if (this.url) data.url = this.url

    return data
  }

  static isLog(data) {
    return typeof data === 'object' && !Array.isArray(data) && data instanceof Date === false
  }
}

export class ErrorLog extends Log {
  constructor(data, logToConsole) {
    super(data)

    this.type = LOG_TYPES.ERROR
    const defaultSeverityLevel = 9
    this.data = {
      ...data,
      severity: data.severity || defaultSeverityLevel,
    }

    if (logToConsole) console.error(`PCLNAnalytics ErrorLog : ${data.message}`)
  }
}

export class EventLog extends Log {
  constructor(data) {
    super(data)

    this.type = LOG_TYPES.EVENT
  }
}

export class SetiLog extends Log {
  constructor(data) {
    super(data)

    this.type = LOG_TYPES.SETI

    this.data = {
      ...data,
      event: 'seti',
    }
  }
}

export class WarningLog extends Log {
  constructor(data, logToConsole) {
    super(data)

    this.type = LOG_TYPES.WARNING

    if (logToConsole) console.warn(`PCLNAnalytics WarningLog : ${data.message}`)
  }
}
